import AdminSearchView from "./admin_search_view";

export { AdminSearchView };
